<app-header class="mainHeader" *ngIf="adminname != '2'"></app-header>

<app-admin-header *ngIf="adminname == '2'"></app-admin-header>
<br><br><br><br><br>
<router-outlet></router-outlet>
<app-footer *ngIf="adminname != '2'"></app-footer>